import config from 'configAlias';
import get from 'lodash/get';
import isPlainObject from 'lodash/isPlainObject';

export const getSharedHeaders = (req = {}) => {
  const groupMember = get(config, 'appConfig.groupMember', '');

  return {
    'content-type': get(req, 'headers.content-type', 'application/json'),
    'x-hsbc-application-type': get(
      req,
      'headers.x-hsbc-application-type',
      get(config, 'appConfig.applicationType', '')
    ),
    'x-hsbc-channel-id': get(
      req,
      'headers.x-hsbc-channel-id',
      get(config, 'appConfig.channelId', '')
    ),
    'x-hsbc-chnl-group-member': get(
      req,
      'headers.x-hsbc-chnl-group-member',
      isPlainObject(groupMember)
        ? groupMember[get(req, 'headers.x-hsbc-brand', __BRAND__)]
        : groupMember
    ),
    'x-hsbc-chnl-countrycode': get(
      req,
      'headers.x-hsbc-chnl-countrycode',
      get(config, 'appConfig.countryCode', '')
    ),
    'x-hsbc-locale': get(req, 'headers.x-hsbc-locale', 'en'),
  };
};
